import { getAuthority } from "@/utils/authority";

const defaultAuth = {"role":"guest"};

export function getCurrentAuthority() {
  let authority = getAuthority();
  if(authority == null){
    return defaultAuth
  }
  return authority;
}

export function check(authority) {
  const current = getCurrentAuthority();
  return authority.includes(current["role"]);
}

export function isLogin() {
  const current = getCurrentAuthority();
  return current && current["role"] !== "guest";
}

export function getClientId() {
  let authority = getAuthority();
  if(authority == null){
    return null
  }
  return authority["clientid"];
}